import { render, staticRenderFns } from "./GroupByTableRow.vue?vue&type=template&id=52935b89&scoped=true"
import script from "./GroupByTableRow.vue?vue&type=script&lang=js"
export * from "./GroupByTableRow.vue?vue&type=script&lang=js"
import style0 from "./GroupByTableRow.vue?vue&type=style&index=0&id=52935b89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52935b89",
  null
  
)

export default component.exports